(function () {
  'use strict';

  function customerId() {
    return window.FUMOYA_CUSTOMER_ID || null;
  }

  function storageKey() {
    var id = customerId();
    return id ? 'fumoya_wishlist_' + id : null;
  }

  function getWishlist() {
    var key = storageKey();
    if (!key) return [];
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    var key = storageKey();
    if (!key) return;
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }

  function isInWishlist(id) {
    return getWishlist().indexOf(String(id)) !== -1;
  }

  function toggleWishlist(id) {
    id = String(id);
    var list = getWishlist();
    var index = list.indexOf(id);
    var added;
    if (index === -1) {
      list.push(id);
      added = true;
    } else {
      list.splice(index, 1);
      added = false;
    }
    setWishlist(list);
    return added;
  }

  function updateButton(button) {
    var id = button.getAttribute('data-product-id');
    if (!id) return;
    var active = isInWishlist(id);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function refreshAllButtons() {
    var buttons = document.querySelectorAll('.wishlist-heart[data-product-id]');
    for (var i = 0; i < buttons.length; i++) updateButton(buttons[i]);
  }

  function redirectToLogin() {
    var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = '/account/login?return_url=' + returnUrl;
  }

  function handleClick(event) {
    var button = event.target.closest ? event.target.closest('.wishlist-heart') : null;
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (!customerId()) {
      redirectToLogin();
      return;
    }

    var id = button.getAttribute('data-product-id');
    if (!id) return;

    toggleWishlist(id);
    updateButton(button);
  }

  document.addEventListener('click', handleClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllButtons);
  } else {
    refreshAllButtons();
  }

  var observer = new MutationObserver(function () {
    refreshAllButtons();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.FumoyaWishlist = {
    get: getWishlist,
    has: isInWishlist,
    toggle: toggleWishlist,
    refresh: refreshAllButtons
  };
})();
